import { EditOutlined, MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';

import type { ModelProductUnit } from '@app/api/Products';
import { EDIT_PRODUCT_PATH } from '@app/constants';
import { stateTitles } from '@app/pages/Warehouses/GoodsUnits/data/constants';
import type {
  GetColumnType,
  GoodsUnitState,
} from '@app/pages/Warehouses/GoodsUnits/types';
import { bigNumberToString } from '@app/utils/bigNumberToString';

import type { ColumnsType } from 'antd/es/table';

export const getGoodsUnitsColumns: GetColumnType = ({ onEditSalePrice }) => {
  const columns: ColumnsType<ModelProductUnit> = [
    {
      title: '№',
      dataIndex: 'Id',
      key: 'Id',
      ellipsis: true,
      width: 80,
    },
    {
      title: 'Дата поступления',
      dataIndex: 'DateAccepted',
      key: 'DateAccepted',
      width: 150,
      render: (date: string) => (
        <span className="no-wrap-text">
          {moment(date).format('DD.MM.YYYY HH:mm')}
        </span>
      ),
    },
    {
      title: 'Товар',
      dataIndex: 'Product',
      key: 'Product',
      width: 180,
      ellipsis: true,
      render: (text: string, row: ModelProductUnit) => (
        <Link
          to={`${EDIT_PRODUCT_PATH}?id=${row?.ProductId?.toString()}`}
          className="no-wrap-text"
          style={{ maxWidth: 400 }}
        >
          {text}
        </Link>
      ),
    },
    {
      title: 'Цена закупки',
      dataIndex: 'PriceOfPurchase',
      key: 'PriceOfPurchase',
      width: 130,
      render: (price) => (
        <span className="no-wrap-text">
          {Number(bigNumberToString(price)).toFixed(2)}
        </span>
      ),
    },
    {
      title: 'Цена продажи',
      dataIndex: 'PriceOfSale',
      key: 'PriceOfSale',
      width: 140,
      render: (text) => <span className="no-wrap-text">{text}</span>,
    },
    {
      title: 'Склад',
      dataIndex: 'Warehouse',
      key: 'Warehouse',
      width: 140,
      ellipsis: true,
      render: (name: string) => {
        return (
          <span className="no-wrap-text" style={{ maxWidth: 300 }}>
            {name}
          </span>
        );
      },
    },
    {
      title: 'Поставщик',
      dataIndex: 'Supplier',
      key: 'Supplier',
      width: 140,
      ellipsis: true,
      render: (name: string) => {
        return (
          <span className="no-wrap-text" style={{ maxWidth: 300 }}>
            {name}
          </span>
        );
      },
    },
    {
      title: 'Кредит',
      dataIndex: 'Credit',
      key: 'Credit',
      width: 100,
      render: (text: number) => <span className="no-wrap-text">{text}</span>,
    },
    {
      title: 'Состояние',
      dataIndex: 'State',
      key: 'State',
      width: 120,
      render: (state: GoodsUnitState) => (
        <span className="no-wrap-text">{stateTitles[state]}</span>
      ),
    },
    {
      title: 'Документы',
      dataIndex: 'CountDocuments',
      key: 'CountDocuments',
      width: 100,
      render: (text: number) => <span className="no-wrap-text">{text}</span>,
    },
    {
      title: null,
      key: 'actions',
      dataIndex: 'actions',
      width: 48,
      fixed: 'right',
      render: (_: unknown, row: ModelProductUnit) => (
        <Dropdown
          placement="bottomLeft"
          menu={{
            items: [
              {
                key: 'edit-sale-price',
                label: 'Изменить цену продажи',
                icon: <EditOutlined />,
              },
            ],
            onClick: ({ key }) => {
              if (key === 'edit-sale-price') {
                onEditSalePrice(row);
              }
            },
          }}
        >
          <Button icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return columns;
};
